import React, { useState } from "react";
import { Modal, Row } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "./ConfirmModal.less";
import { useTranslation } from "react-i18next";

const ConfirmModal = ({ title = "", text = "", isVisible, setIsVisible, promiseResolve }) => {
  const { t } = useTranslation();
  const handleOk = () => {
    setIsVisible(false);
    promiseResolve(true);
  };

  const handleCancel = () => {
    setIsVisible(false);
    promiseResolve(false);
  };

  return (
    <Modal
      open={isVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      okButtonProps={{ style: { width: "180px" } }}
      cancelButtonProps={{ style: { width: "180px" } }}
      okText={t("YES")}
      cancelText={t("NO")}
      className="modalConfirm"
    >
      <Row justify="center" align="middle" style={{ marginBottom: "25px" }}>
        <span style={{ fontSize: "25px", fontWeight: "bold" }}>{title}</span>
      </Row>
      {text.split("\n").map((line, idx) => (
        <Row key={idx}>
          <span style={{ fontSize: "20px" }}>{line}</span>
        </Row>
      ))}
    </Modal>
  );
};

export default ConfirmModal;

export const useConfirmModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [promiseResolve, setPromiseResolve] = useState(null);
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");

  const prompt = (title, text) => {
    setIsVisible(true);
    setTitle(title);
    setText(text);
    return new Promise(resolve => {
      setPromiseResolve(() => resolve);
    });
  };

  return [
    prompt,
    <ConfirmModal
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      promiseResolve={promiseResolve}
      title={title}
      text={text}
    />,
  ];
};
